/**
 * Profile synchronization helpers.
 */
import { ensureSettings } from '../../modules/state';
import { toServerSettings } from '../../modules/settingsSync';
import type { SettingsHandlerDeps } from './types';

export interface ProfileSyncResult {
  attempted: boolean;
  success: boolean;
}

export async function syncProfile(deps: SettingsHandlerDeps): Promise<ProfileSyncResult> {
  const { els, cfg, upsertUserProfile } = deps;

  const company = els.profileCompany?.value?.trim() || '';
  const update: Record<string, unknown> = {
    // Server-backed decision settings (fees, target margin, notifications)
    settings: toServerSettings(ensureSettings()),
  };
  if (company) {
    update.company = company;
  }

  try {
    const ok = await upsertUserProfile(cfg, update);
    return { attempted: true, success: ok !== false };
  } catch {
    return { attempted: true, success: false };
  }
}
